"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.41939 17H4.84797V5.57506H1.41939V17ZM14.7729 5.17918C13.9674 5.1516 13.1668 5.31362 12.4354 5.65218C11.704 5.99074 11.0624 6.49637 10.5623 7.12833V5.53754H7.12521V17H10.5623V10.8015C10.5963 10.1061 10.8955 9.45025 11.3984 8.9688C11.9012 8.48734 12.5695 8.21689 13.2656 8.21308C14.7693 8.21308 15.1397 9.49153 15.1397 10.7688V16.9988H18.5671V10.5145C18.5707 6.00969 16.4388 5.17918 14.7741 5.17918H14.7729ZM3.11673 4.43342C3.45632 4.43342 3.78827 4.3327 4.07061 4.14402C4.35295 3.95533 4.57298 3.68714 4.70288 3.37338C4.83278 3.05963 4.8667 2.71439 4.80036 2.38135C4.73402 2.04831 4.57041 1.74243 4.3302 1.50239C4.08999 1.26235 3.78399 1.09894 3.4509 1.03284C3.11781 0.966737 2.77261 1.00091 2.45894 1.13102C2.14527 1.26114 1.87724 1.48137 1.68875 1.76384C1.50026 2.04631 1.39979 2.37834 1.40002 2.71792C1.40018 2.94336 1.44475 3.16656 1.53117 3.37478C1.61758 3.583 1.74417 3.77216 1.90369 3.93146C2.06322 4.09075 2.25256 4.21707 2.4609 4.3032C2.66924 4.38933 2.8925 4.43358 3.11794 4.43342H3.11673Z",
    fill: fill
  }));
};

exports["default"] = _default;